import React from "react";
import "./PopeyeDealsCard.scss";
import { getIcon, getFlag } from '../../../../utils/images';

const PopeyeDealsCard = ({ deal }) => {
  return (
    <div
      className="rolling-deals-section__element"
      data-from={deal.pol.name}
      data-to={deal.pod.name}
      // data-price={deal.sea_freight.toFixed(0)} 
      data-url={`/shipments/search?origin_port=${deal.pol.name}&destination_port=${deal.pod.name}&containers=${encodeURIComponent(JSON.stringify([`${deal.container_type.name}:1`]))}`}
      onClick={(e) => {
        const url = e.currentTarget.getAttribute('data-url');
        window.location.href = url; // Navigate to the URL
      }}
    >
      <div className="info">
        <div className="info__track">
          <div className="info__location">
            <img
              src={getFlag(deal.pol.code)}
              className="flag"
              alt={deal.pol.code}
            />
            <div className="info__port" data-target="pol">
              {deal.pol.name}
            </div>
          </div>

          <img
            src={getIcon("small-sea")} alt="sea-freight" className="sea-freight"/>
          <div className="info__location">
            <img
              src={getFlag(deal.pod.code)}
              className="flag"
              alt={deal.pod.code}
            />
            <div className="info__port" data-target="pod">
              {deal.pod.name}
            </div>
          </div>
        </div>

        <div className="items" dir="auto">
          <div className="items__container notranslate" translate="no">
            <img
              src={getIcon("small-container")}
              alt="cargo-container"
            />
            <span>{deal.container_type.code}</span>
          </div>
          <div className="items__freight">
            <span className="price">
              {deal.price}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopeyeDealsCard;
